import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Analytics } from "@vercel/analytics/react";

// Detect react-snap prerendering — set flag before anything else runs
// react-snap crawls with userAgent = 'ReactSnap'; no backend is available
if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') {
  window.__isPrerendering = true;
}

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);

// When react-snap pre-rendered the page, hydrate instead of render (for SEO/crawlers)
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

